export default __webpack_public_path__ + "static/luzean-privacy-546ea4499d579503ff0d25e90bf7278a.webp";